import { Link, useLocation } from "react-router-dom";
import SiteHeader from "@/components/feature/SiteHeader";
import SiteFooter from "@/components/feature/SiteFooter";

export default function NotFound() {
  const location = useLocation();

  return (
    <div className="min-h-screen flex flex-col bg-background-50">
      <SiteHeader />
      <main className="flex-1 flex flex-col items-center justify-center text-center px-4 py-20">
        <div className="relative">
          <span className="font-heading text-[7rem] md:text-[10rem] font-black text-background-200 leading-none select-none">
            404
          </span>
          <span className="absolute inset-0 flex items-center justify-center">
            <i className="ri-ghost-line text-4xl md:text-5xl text-primary-500"></i>
          </span>
        </div>
        <h1 className="mt-4 font-heading text-xl md:text-2xl font-black text-foreground-950">
          页面走丢了
        </h1>
        <p className="mt-2 text-sm text-foreground-500">
          你要访问的页面不存在或已被移除
        </p>
        <p className="mt-1 text-xs text-foreground-400 font-mono">{location.pathname}</p>
        <div className="mt-6 flex flex-wrap items-center justify-center gap-3">
          <Link
            to="/"
            className="px-5 py-2.5 rounded-md bg-primary-500 text-background-50 text-sm font-semibold whitespace-nowrap cursor-pointer hover:bg-primary-600 transition-colors"
          >
            返回首页
          </Link>
          <Link
            to="/category/tv"
            className="px-5 py-2.5 rounded-md bg-background-50 border border-background-300 text-foreground-800 text-sm font-medium whitespace-nowrap cursor-pointer hover:border-primary-400 hover:text-primary-600 transition-colors"
          >
            去看看影视
          </Link>
        </div>
      </main>
      <SiteFooter />
    </div>
  );
}